import { Card, CardBody, CardHeader, FormLabel, Loading, SingleSelectControl } from "@dgs/core";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { useGlobalTenants } from "../../../tenants/global/GlobalTenantProvider";
import { LoadingOverlay } from "../common/LoadingOverlay";
import { TestDrivesList } from "./TestDrivesList";
import { useCarFleetApplicationSelect } from "./useCarFleetApplicationSelect";

const StyledCard = styled(Card)`
	position: relative;
	grid-column: 1/3;
`;

const SelectWrapper = styled(CardBody)`
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: ${({ theme }) => theme.spacing(3)};
	padding-bottom: 0;
	padding-top: ${({ theme }) => theme.spacing(2)};
	border-bottom: 1px solid ${({ theme }) => theme.colors.card.background.border};
`;

const SubHeaderSection = styled.div`
	${({ theme }) => theme.forms.control};
`;

const SubHeaderValue = styled.div`
	display: flex;
	align-items: center;
`;

const SelectControlWrapper = styled.div`
	padding-bottom: ${({ theme }) => theme.spacing(2)};
`;

export const TestDrivesWidget = () => {
	const { t } = useTranslation();
	const selectProps = useCarFleetApplicationSelect();
	const { selected } = useGlobalTenants();

	if (selectProps.type === "unrenderable" || !selected.tenant) {
		return null;
	}

	const showHeader = selectProps.type === "ready" && selectProps.applicationSelect.options.length > 1;

	return (
		<StyledCard>
			<CardHeader>{t("Current & Upcoming Test Drives")}</CardHeader>
			{showHeader && (
				<SelectWrapper>
					{selectProps.applicationSelect.options.length === 1 ? (
						<SubHeaderSection>
							<FormLabel>{t("Application")}</FormLabel>
							<SubHeaderValue>{selectProps.applicationSelect.value.subdomain}</SubHeaderValue>
						</SubHeaderSection>
					) : (
						<SelectControlWrapper>
							<SingleSelectControl
								name="application"
								{...selectProps.applicationSelect}
								clearable={false}
								getLabel={(x) => x.subdomain}
								label={t("Application")}
							/>
						</SelectControlWrapper>
					)}
				</SelectWrapper>
			)}
			{selectProps.type === "ready" && (
				<TestDrivesList application={selectProps.applicationSelect.value} tenantId={selected.tenant.id} />
			)}
			{selectProps.type === "isLoading" && (
				<LoadingOverlay>
					<Loading />
				</LoadingOverlay>
			)}
		</StyledCard>
	);
};
